export const piechartOptions: Highcharts.Options = {
  // accessibility: {
  //   enabled: true,
  //   point: {
  //     valueSuffix: '%',
  //   },
  //   keyboardNavigation: {
  //     enabled: true,
  //   },
  // },
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
  },
  colors: ['#01D788', '#FE5A58', '#FFCF50', '#5D62F6'],
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 400,
        },
        chartOptions: {
          legend: {
            enabled: false,
          },
        },
      },
    ],
  },
  title: {
    text: '',
  },
  tooltip: {
    pointFormat:
      '<span style="color:{point.color}">\u25CF</span>: <b>${point.y}</b> ({point.percentage:.0f}%)<br/>',
  },
  xAxis: {
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
  },
  yAxis: {
    min: 0,
    max: 100,
    labels: {
      formatter: function () {
        return '';
      },
      style: {
        color: '#4572A7',
      },
    },
  },
};
